import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Button, Dialog, TextField, useMediaQuery} from "@mui/material";
import * as React from "react";
import {useState} from "react";

const DeleteFeeDialog = ({ open, feeName, onClose, onConfirm }) => {
    const sizeMatch = useMediaQuery('@media (min-width:600px)')
    const [reason, setReason] = useState('')

    const handleClose = () => {
        setReason('')
        onClose()
    }

    const handleConfirm = () => {
        onConfirm(reason)
        setReason('')
    }

    return (
        <Dialog
            fullScreen={!sizeMatch}
            sx={{ '& .MuiDialog-paper': { width: '100%', maxWidth: '600px' }, padding: 2 }}
            maxWidth="xs"
            open={open}
            onClick={event => event.stopPropagation()}
        >
            <DialogTitle>{"Excluir Item da Fatura"}</DialogTitle>
            <DialogContent>
                <strong>{"Atenção"}</strong>
                <br/>
                {feeName && <>Item: <strong>{feeName}</strong><br/><br/></>}
                {"Deseja realmente excluir este item? O valor total da fatura será recalculado."}
                <TextField
                    autoFocus
                    margin="dense"
                    label="Motivo da exclusão"
                    fullWidth
                    multiline
                    rows={3}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    sx={{ mt: 2 }}
                    required
                />
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between' }}>
                <Button onClick={handleClose}>{"Cancelar"}</Button>
                <Button
                    variant={"contained"}
                    color={"error"}
                    onClick={handleConfirm}
                    disabled={!reason.trim()}
                >
                    {"Excluir"}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default DeleteFeeDialog
